import { Component, Input } from '@angular/core';
import { SCV2_CARRIERS, SCV2_STORE_ADDRESS, SCV2_STORE_NAME, ShippingOrderV2 } from '../../shipping-config-v2.service';

@Component({
  selector: 'app-shipping-label-v2',
  templateUrl: './shipping-label-v2.component.html',
  styleUrls: ['./shipping-label-v2.component.scss'],
})
export class ShippingLabelV2Component {
  @Input() order!: ShippingOrderV2;

  storeName = SCV2_STORE_NAME;
  storeAddress = SCV2_STORE_ADDRESS;

  get carrierName(): string {
    return (this.order.carrierId && SCV2_CARRIERS[this.order.carrierId]?.name) || 'CARRIER';
  }
}
